import React, { SVGProps } from 'react';

export const VerticalDotsIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 13 14"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M6.5 3.75a1.218 1.218 0 1 1 0-2.437 1.218 1.218 0 0 1 0 2.437ZM7.719 7a1.218 1.218 0 1 0-2.437-.001 1.218 1.218 0 0 0 2.437 0Zm0 4.469a1.219 1.219 0 0 0-2.437-.001 1.219 1.219 0 0 0 2.437 0Z"
      />
    </svg>
  );
};
